export default __webpack_public_path__ + "static/media/vesting_white.64776d86.svg";